/** Feature keys matching the backend Feature enum in feature_matrix.py */
export const Feature = {
  DATA_SOURCE_CSV_UPLOAD: 'data_source_csv_upload',
  DATA_SOURCE_PEOPLE_SEARCH: 'data_source_people_search',
  DATA_SOURCE_SALES_NAV: 'data_source_sales_nav',
  DATA_SOURCE_COMPANY_UPLOAD: 'data_source_company_upload',
  DATA_SOURCE_CRM_IMPORT: 'data_source_crm_import',
  SMART_COLUMNS_BASIC: 'smart_columns_basic',
  SMART_COLUMNS_AI: 'smart_columns_ai',
  AGENTS: 'agents',
  PLAYBOOKS: 'playbooks',
  CRM_INTEGRATIONS: 'crm_integrations',
  IN_CRM_ENRICHMENT: 'in_crm_enrichment',
  API_ACCESS: 'api_access',
  ANALYTICS: 'analytics',
  EXPORTS: 'exports',
  /** Native sequencing (Sequences, Inbox, Tasks): Scale. */
  ENGAGE: 'engage',
  SLACK_AGENT: 'slack_agent',
  /** Native dialer (calling from Cleanlist): plans that run sequences, never a
   * trial or an AppSumo-only deal. */
  DIALER: 'dialer',
} as const;

export type FeatureKey = (typeof Feature)[keyof typeof Feature];

// Tier-gating LOGIC (TIER_RANK, FRONTEND_TIER_GATED_FEATURES,
// APPSUMO_BYPASS_FEATURES) was removed in the backend-driven entitlements
// overhaul. Gating is now a single backend matrix; the FE reads it via
// useFeatureAccess().hasFeature() — a dense capability-map lookup, no tier
// math and no AppSumo carve-out sets. The maps below are DISPLAY-COPY ONLY
// (upgrade-prompt labels via getRequiredTier), NOT gating inputs.

export const TIER_LABELS: Record<string, string> = {
  free: 'Free',
  starter: 'Starter',
  pro: 'Pro',
  scale: 'Enterprise',
  // Legacy. Kept so existing customers' tier_category resolves to a
  // human-readable label until they migrate to V2.
  enterprise: 'Enterprise',
};

export const FEATURE_REQUIRED_TIER: Record<FeatureKey, string> = {
  [Feature.DATA_SOURCE_CSV_UPLOAD]: 'free',
  [Feature.DATA_SOURCE_PEOPLE_SEARCH]: 'starter',
  [Feature.DATA_SOURCE_SALES_NAV]: 'starter',
  [Feature.DATA_SOURCE_COMPANY_UPLOAD]: 'starter',
  [Feature.DATA_SOURCE_CRM_IMPORT]: 'pro',
  [Feature.SMART_COLUMNS_BASIC]: 'starter',
  [Feature.SMART_COLUMNS_AI]: 'pro',
  [Feature.AGENTS]: 'starter',
  [Feature.PLAYBOOKS]: 'scale',
  [Feature.CRM_INTEGRATIONS]: 'pro',
  [Feature.IN_CRM_ENRICHMENT]: 'scale',
  [Feature.API_ACCESS]: 'pro',
  [Feature.ANALYTICS]: 'scale',
  [Feature.EXPORTS]: 'starter',
  [Feature.ENGAGE]: 'scale',
  [Feature.SLACK_AGENT]: 'pro',
  [Feature.DIALER]: 'scale',
};

/** Display copy for the new catalog; capabilities still come from the API. */
export const V4_FEATURE_REQUIRED_TIER: Record<FeatureKey, string> = {
  ...FEATURE_REQUIRED_TIER,
  [Feature.DATA_SOURCE_CSV_UPLOAD]: 'free',
  [Feature.EXPORTS]: 'free',
  [Feature.PLAYBOOKS]: 'pro',
  [Feature.IN_CRM_ENRICHMENT]: 'pro',
  [Feature.ANALYTICS]: 'pro',
  [Feature.ENGAGE]: 'starter',
  [Feature.DIALER]: 'starter',
};
